import { render, staticRenderFns } from "./oeItemMore.vue?vue&type=template&id=74106419&lang=pug&"
import script from "./oeItemMore.vue?vue&type=script&lang=js&"
export * from "./oeItemMore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports